import { useDispatch } from "react-redux";
import {
  addToCart,
  // deleteProduct,
} from "../redux/cart/actions";

export default function Product({ product }) {
  const dispatch = useDispatch();

  return (
    <div className="lws-productCard">
      <img className="lws-productImage" src={product.imageURL} alt="product" />
      <div className="p-4 space-y-2">
        <h4 className="lws-productName">{product.name}</h4>
        <p className="lws-productCategory">{product.category}</p>
        <div className="flex items-center justify-between pb-2">
          <p className="productPrice">
            BDT <span className="lws-price">{product.price}</span>
          </p>
          <p className="productQuantity">
            QTY <span className="lws-quantity">{product.count}</span>
          </p>
        </div>
        <button
          className="lws-btnAddToCart"
          onClick={() => dispatch(addToCart(product.id))}
          disabled={!product.count}
        >
          Add To Cart
        </button>
        {/* {product.totalOrder ? (
          <button
            className="lws-btnRemoveFromCart"
            onClick={() => dispatch(deleteProduct(product.id))}
            disabled={!product.totalOrder}
          >
            Remove From Cart
          </button>
        ) : (
          ""
        )} */}
      </div>
    </div>
  );
}
